import { useEffect } from 'react';

import { env } from '@/app/config/env';

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} | ${env.APP_NAME}` : env.APP_NAME;
  }, [title]);
}
